import * as React from 'react';
import { Image, useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';
import img from './assets/success.png';
import { Typography } from '../../../Typography';
import { Button } from '../../../Button';

export interface ISuccessScreenProps {
  onClose: () => void;
  type: 'apply' | 'recommend';
}

export const SuccessScreen: React.FC<ISuccessScreenProps> = ({ onClose, type }) => {
  const deviceType = useDeviceType();

  return (
    <div className={styles.content}>
      <div className={styles.text}>
        <Typography.Title level={deviceType === 'desktop' ? 3 : 5}>Отклик отправлен</Typography.Title>
        {type === 'recommend' && (
          <Typography.Text level={deviceType === 'desktop' ? 2 : 3}>Спасибо за рекомендацию!</Typography.Text>
        )}
      </div>
      {type === 'apply' ? (
        <div className={styles.text}>
          <Typography.Text level={deviceType === 'desktop' ? 3 : 5}>
            Свяжемся с вами в ближайшее время через указанный/ые каналы связи
          </Typography.Text>
        </div>
      ) : (
        <>
          <div className={styles.text}>
            <Typography.Text level={deviceType === 'desktop' ? 3 : 5}>
              Резюме уже у рекрутера. Мы рассматриваем кандидатов в течение <b>24 часов.</b> После этого сразу свяжемся
              с тобой и сообщим, подходит ли кандидат на вакансию.
            </Typography.Text>
          </div>
          <div className={styles.text}>
            <Typography.Text level={deviceType === 'desktop' ? 3 : 5}>
              Далее все общение будет вестись напрямую с кандидатом — если захочешь узнать статус, просто обратись к
              нему.
            </Typography.Text>
          </div>
        </>
      )}

      <div className={styles['image-container']}>
        <Image src={img} width={deviceType === 'desktop' ? 'min(30vw, 648px)' : '100%'} height={'auto'} />
      </div>
      <div className={styles.ok}>
        <Button onClick={onClose} fullWidth>
          Супер
        </Button>
      </div>
    </div>
  );
};
